module.exports = __webpack_public_path__ + "img/health22_7-9-2021.1113923c.jpg";